// Added in order of response from Google forms
export default [
  {
    id: 0,
    videos:[
      "https://www.youtube.com/watch?v=HOeIASjxPGE",
      "https://www.youtube.com/watch?v=-QH8fRhqFHM",
      "https://www.youtube.com/watch?v=90h7Pzaoys8",
      "https://www.youtube.com/watch?v=65Deh9u2pLw",
      "https://www.youtube.com/watch?v=CBHhEhkZeis",
      "https://www.youtube.com/watch?v=RMAuB_3otbo",
      "https://www.youtube.com/watch?v=J0p_thJJnoo",
      "https://www.youtube.com/watch?v=DXp3gWEl5ME"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'He/him/his',
      geo: 'Brooklyn, NY, USA',
      race: 'White',
      age: '25-35'
    }
  },
  {
    id: 1,
    videos:[
      "https://www.youtube.com/watch?v=-GBlxrN0fUM",
      "https://www.youtube.com/watch?v=iJAKCV8bw9E",
      "https://www.youtube.com/watch?v=aQvxWaUwlGA",
      "https://www.youtube.com/watch?v=ExvEIOWB-H0",
      "https://www.youtube.com/watch?v=ETPogv1zq08",
      "https://www.youtube.com/watch?v=xzi_Gbgj9AQ",
      "https://www.youtube.com/watch?v=LY_Yiu2U2Ts",
      "https://www.youtube.com/watch?v=Tw19gqOOAHw"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'He/him/his',
      geo: 'Brooklyn, NY, USA',
      race: 'White',
      age: '18-25'
    }
  },
  {
    id: 2,
    videos:[
      "https://youtu.be/qPxhzxaIkNE",
      "https://youtu.be/JLUtbbMByx8",
      "https://youtu.be/Gk8e3Lg5GFU",
      "https://youtu.be/1HA4zY8xCyY",
      "https://youtu.be/n_lqtqsXzkM",
      "https://youtu.be/AO4PrtAKu2E",
      "https://youtu.be/cXFb2JrR_BE",
      "https://youtu.be/88uwWAVyvPY"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'She/her/hers',
      geo: 'New York City, NY, USA',
      race: 'Asian or Asian American',
      age: '25-35'
    }
  },
  {
    id: 3,
    videos:[
      "https://www.youtube.com/watch?v=uj2zDix25Qw",
      "https://www.youtube.com/watch?v=SIaVHrH5Lwo",
      "https://www.youtube.com/watch?v=mPZkdNFkNps",
      "https://www.youtube.com/watch?v=_Bjf-iExroI",
      "https://www.youtube.com/watch?v=4CzYXfBeIdM",
      "https://www.youtube.com/watch?v=ASm3EJAFjYQ",
      "https://www.youtube.com/watch?v=GduwxBZAxs4",
      "https://www.youtube.com/watch?v=Ql99R0lbSr4"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'He/him/his',
      geo: 'Miami, FL, USA',
      race: 'White',
      age: '25-35'
    }
  },
  {
    id: 4,
    videos:[
      "https://www.youtube.com/watch?v=cXFb2JrR_BE",
      "https://www.youtube.com/watch?v=5qap5aO4i9A",
      "https://www.youtube.com/watch?v=KDlO64GbxIQ",
      "https://www.youtube.com/watch?v=UZw-CU32Uqc",
      "https://www.youtube.com/watch?v=TQHEJj68Jew",
      "https://www.youtube.com/watch?v=4wEO_JuON9E",
      "https://www.youtube.com/watch?v=EgSiX6LKO1I",
      "https://www.youtube.com/watch?v=fcddr9t1LqM"
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'He/him/his',
      geo: 'Maryland, USA',
      race: 'White',
      age: '25-35'
    }
  },
  {
    id: 5,
    videos:[
      "https://www.youtube.com/watch?v=w_Ma8oQLmSM",
      "https://www.youtube.com/watch?v=FS36tntGKQY",
      "https://www.youtube.com/watch?v=RwM71mSFN2o",
      "https://www.youtube.com/watch?v=k7TMI5XpRCY",
      "https://www.youtube.com/watch?v=EJTu_mRvaIU",
      "https://www.youtube.com/watch?v=mTwAZGyGX0w",
      "https://www.youtube.com/watch?v=MopgfocPqhI",
      "https://www.youtube.com/watch?v=vfNZrlXMJrs"
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'She/her/hers',
      geo: 'Hayward, CA, USA',
      race: 'Asian or Asian American',
      age: '25-35'
    }
  },
  {
    id: 6,
    videos:[
      "https://youtu.be/AiwY5G1_5GY",
      "https://youtu.be/6A-IoOEPbUs",
      "https://youtu.be/v7qePMse_m8",
      "https://youtu.be/oNqhF839QVg",
      "https://youtu.be/_ueepVVGWyI",
      "https://youtu.be/INIrQ2TOS5Q",
      "https://youtu.be/p_VSj-577fU",
      "https://youtu.be/ntn6q-ODULo"
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'He/him/his',
      geo: 'Aurora, CO, USA',
      race: 'Asian or Asian American',
      age: '18-25'
    }
  },
  {
    id: 7,
    videos:[
      "https://youtu.be/-lGTKtqtXeE",
      "https://youtu.be/9BMwcO6_hyA",
      "https://youtu.be/8SbUC-UaAxE",
      "https://youtu.be/u7HOIl0BaFc",
      "https://youtu.be/E45ne-9jSEY",
      "https://youtu.be/CL6m9phZfVo",
      "https://youtu.be/JjAjSRZogGg",
      "https://youtu.be/Lwc8bw0V-co",
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'She/her/hers',
      geo: 'Miami, FL, USA',
      race: 'White',
      age: '35-50'
    }
  },
  {
    id: 11,
    videos:[
      "https://www.youtube.com/watch?v=5t2mMXLUrco",
      "https://www.youtube.com/watch?v=hnwLUsUJOwc",
      "https://www.youtube.com/watch?v=lgICbOwP7NQ",
      "https://www.youtube.com/watch?v=OOHXJX9J_is",
      "https://www.youtube.com/watch?v=iDAcnp7IE48",
      "https://www.youtube.com/watch?v=kqBtSog8zSQ",
      "https://www.youtube.com/watch?v=UiBY14Ndsn8",
      "https://www.youtube.com/watch?v=TtRgxoqnuZQ"
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'He/him/his',
      geo: 'Wilkeson, WA, USA',
      race: 'White',
      age: '25-35'
    }
  },
  {
    id: 12,
    videos:[
      "https://www.youtube.com/watch?v=0MKH0RsdDIQ",
      "https://www.youtube.com/watch?v=TBc-VZwvXpw",
      "https://www.youtube.com/watch?v=cij0pxAK9w0",
      "https://www.youtube.com/watch?v=rgN615Pli24",
      "https://www.youtube.com/watch?v=AcnOLiGR38c",
      "https://www.youtube.com/watch?v=xXksJZ7gqOg",
      "https://www.youtube.com/watch?v=HzVA6Fh167E",
      "https://www.youtube.com/watch?v=Bh87V3f0FaA&list=PLU12uITxBEPHk63O2LOy18ANgM6m-R4f3"
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'He/him/his',
      geo: 'Malinta, Ohio, USA',
      race: 'White',
      age: '35-50'
    }
  },
  {
    id: 14,
    videos:[
      "https://www.youtube.com/watch?v=O7wEsZpyrCQ",
      "https://www.youtube.com/watch?v=mpHlRC4evuk",
      "https://www.youtube.com/watch?v=66TYJJObd6E",
      "https://www.youtube.com/watch?v=yfy7M5eG1HI",
      "https://www.youtube.com/watch?v=NLcim9EPx6c",
      "https://www.youtube.com/watch?v=Fc7-Oe0tj5k",
      "https://www.youtube.com/watch?v=5wq8kkdDDts",
      "https://www.youtube.com/watch?v=1WHPExTeOwg"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'He/him/his',
      geo: 'Chicago, IL, USA',
      race: 'Black or African American',
      age: '18-25'
    }
  },
  {
    id: 15,
    videos:[
      "https://www.youtube.com/watch?v=fxlQs8wpgNQ",
      "https://www.youtube.com/watch?v=Hqg7STPLrz4",
      "https://www.youtube.com/watch?v=4sGoePChQ6U",
      "https://www.youtube.com/watch?v=qPkbVgeOXI0",
      "https://www.youtube.com/watch?v=7NDWyvWBmz4",
      "https://www.youtube.com/watch?v=os3e-dpA9QI"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'He/him/his',
      geo: 'Georgia, USA',
      race: 'White',
      age: '25-35'
    }
  },
  {
    id: 16,
    videos:[
      "https://www.youtube.com/watch?v=_iR6OsMro5c",
      "https://www.youtube.com/watch?v=iAR4hpzPebY",
      "https://www.youtube.com/watch?v=VFBAcz16GvU",
      "https://www.youtube.com/watch?v=BVxvH3Qabgw",
      "https://www.youtube.com/watch?v=Mo-6XlVej50",
      "https://www.youtube.com/watch?v=KV5QlSgq7lg",
      "https://www.youtube.com/watch?v=G0jUE2Ykz2I"
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'He/him/his',
      geo: 'Dallas, Texas, USA',
      race: 'White',
      age: '25-35'
    }
  },
  {
    id: 17,
    videos:[
      "https://www.youtube.com/watch?v=23jzbGPZP8k",
      "https://www.youtube.com/watch?v=ht__G2aTtj4",
      "https://www.youtube.com/watch?v=7ECL4ISf7_A",
      "https://www.youtube.com/watch?v=JStBWNeFw8A",
      "https://www.youtube.com/watch?v=99eyQJibs3c",
      "https://www.youtube.com/watch?v=8-S2ARXzf0k",
      "https://www.youtube.com/watch?v=p7ZfIX7OGko",
      "https://www.youtube.com/watch?v=Bh87V3f0FaA&list=PLU12uITxBEPHk63O2LOy18ANgM6m-R4f3"
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'He/him/his',
      geo: 'Richardson, Texas, USA',
      race: 'White',
      age: '35-50'
    }
  },
  {
    id: 18,
    videos:[
      "https://www.youtube.com/watch?v=LIIDh-qI9oI",
      "https://www.youtube.com/watch?v=MWe40nEspDM",
      "https://www.youtube.com/watch?v=d8ioCR7Gta0",
      "https://www.youtube.com/watch?v=hgKS9kfT0hQ",
      "https://www.youtube.com/watch?v=QUaMEVFgYwI",
      "https://www.youtube.com/watch?v=2ajtpjgHnOw",
      "https://www.youtube.com/watch?v=OZAtiSjzeho",
      "https://www.youtube.com/watch?v=1TRgkKNWFIA"
    ],
    demographics:{
      candidate: 'Trump',
      pronouns: 'He/him/his',
      geo: 'Alabaster, AL, USA',
      race: 'Black or African American',
      age: '18-25'
    }
  },
  {
    id: 19,
    videos:[
      "https://www.youtube.com/watch?v=DJ_caPDat4M",
      "https://www.youtube.com/watch?v=roGnm_0lkag",
      "https://www.youtube.com/watch?v=Ie1VnywFcfY",
      "https://www.youtube.com/watch?v=bn8TJA09gP8&t=60s",
      "https://www.youtube.com/watch?v=kor6mPFmGBU",
      "https://www.youtube.com/watch?v=bGmiTTLA4NY&t=4s",
      "https://www.youtube.com/watch?v=dQwVy49a5bE",
      "https://www.youtube.com/watch?v=Y5Ww7BgmOWA"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'She/her/hers',
      geo: 'VA, USA',
      race: 'White',
      age: '25-35'
    }
  },
  {
    id: 20,
    videos:[
      "https://youtu.be/3YdHtDPIjio",
      "https://youtu.be/p5GPD-gCpFg",
      "https://youtu.be/kd7w8yvH5ws",
      "https://youtu.be/FuDdstaZXdw",
      "https://youtu.be/FbysVaaIrhk",
      "https://youtu.be/jPRDv9eqzEU",
      "https://youtu.be/SLzckCNxHZQ",
      "https://youtu.be/PfpEefKiG2I"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'He/him/his',
      geo: 'Dyersburg, TN, USA',
      race: 'Latinx/Hispanic',
      age: '18-25'
    }
  },
  {
    id: 21,
    videos:[
      "https://www.youtube.com/watch?v=a5C_CWpNjhA",
      "https://www.youtube.com/watch?v=_4kHxtiuML0",
      "https://www.youtube.com/watch?v=8-S2ARXzf0k",
      "https://www.youtube.com/watch?v=SzuZnh91U8E",
      "https://www.youtube.com/watch?v=cXFb2JrR_BE",
      "https://www.youtube.com/watch?v=Vr-I6w3MDTw",
      "https://www.youtube.com/watch?v=vOgpNjeh1EA"
    ],
    demographics:{
      candidate: 'Biden',
      pronouns: 'He/him/his',
      geo: 'New York City, NY, USA',
      race: 'White',
      age: '25-35'
    }
  }
]